import { Link } from 'react-router-dom';
import type { IKpiTileProps } from './IKpiTileProps';

/**
 * Плитка показника (прототип v4 admKpis/custKpis): підпис 11px великими літерами, значення 30px/300, примітка 12px; рамка підсвічується
 * акцентом при наведенні, клік відкриває відповідний розділ.
 */
export function KpiTile({ label, value, note, to }: IKpiTileProps) {
  const body = (
    <>
      <span className="sp-kpi__label">{label}</span>
      <span className="sp-kpi__value">{value}</span>
      <span className="sp-kpi__note">{note ?? ''}</span>
    </>
  );
  return to ? <Link className="sp-kpi" to={to}>{body}</Link> : <div className="sp-kpi">{body}</div>;
}
